// Loading prop for page load (use when NProgress bar is insufficient for whatever reason)
import { useRouter } from "@tanstack/react-router";
import { useEffect, useState } from "react";

function usePageLoading(): boolean {
  const router = useRouter();
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    const unsubStart = router.subscribe("onBeforeNavigate", () => {
      setPageLoading(true);
    });
    const unsubEnd = router.subscribe("onResolved", () => {
      setPageLoading(false);
    });

    return () => {
      unsubStart();
      unsubEnd();
    };
  }, [router]);

  return pageLoading;
}

export default usePageLoading;
